import { render, staticRenderFns } from "./VMSSelect.vue?vue&type=template&id=af80d162"
import script from "./VMSSelect.vue?vue&type=script&lang=ts"
export * from "./VMSSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports